import { createApp, type Component } from 'vue';
import { createPinia } from 'pinia';
import router from '@/router';
import theApp from '@/App.vue';

import '@/theme/tokens.scss';
import '@/theme/focus.scss';
import '@/theme/form-controls.scss';
import '@/theme/tables.scss';
import '@/theme/wizard.scss';

import { VERSION, DEPLOY_ENV } from '@/buildInfo';
import { logger } from '@/utils/logger';
import { installZodErrorMessages } from '@/schemas/zodErrors';

const pinia = createPinia();

installZodErrorMessages();

/* `theApp` resolves as `any` outside vue-tsc, because eslint's parser does not carry
   the SFC's inferred default-export type. `Component` is what createApp actually
   accepts — the previous `as App` named createApp's return type instead, which is why
   vue-tsc rejected it as a non-overlapping cast. */
const app = createApp(theApp as Component);

app.use(pinia);

/* No VueQueryPlugin: the query cache is provided per scope by QueryScopeProvider
   (see src/trpc/queryClients.ts). With no app-level fallback client, a useQuery /
   useQueryClient call outside that provider throws at setup instead of silently
   reading a cache that belongs to no firm. */
app.use(router);
app.mount('#app');

logger.info(`loaded ${DEPLOY_ENV} ${VERSION}`);
